export enum CanvasTemplateOptionEnum {
    STYLES                   = 'STYLES',
    CONTENT_BLOCK            = 'CONTENT_BLOCK',
    SECTION_RULES            = 'SECTION_RULES',
    SCHEDULING               = 'SCHEDULING',
    // DIGESTS                  = 'DIGESTS',
    PUBLISHING_NOTIFICATIONS = 'PUBLISHING_NOTIFICATIONS',
    MAILING_LISTS            = 'MAILING_LISTS',
    RECIPIENTS               = 'RECIPIENTS',
    FROM_NAME                = 'FROM_NAME',
    REPLY_TO                 = 'REPLY_TO',
    INVITE_MESSAGE           = 'INVITE_MESSAGE',
    NOTIFICATION_STYLE       = 'NOTIFICATION_STYLE',
}

export interface CanvasSaveTemplateOption {
    [key: string]: boolean;
}

export const canvasTemplateContentNodes: Map<CanvasTemplateOptionEnum, CanvasTemplateOptionEnum[]> = new Map([
    [CanvasTemplateOptionEnum.STYLES, []],
    [CanvasTemplateOptionEnum.CONTENT_BLOCK, []],
    [CanvasTemplateOptionEnum.SECTION_RULES, []],
    [CanvasTemplateOptionEnum.SCHEDULING, []],
    // [CanvasTemplateOptionEnum.DIGESTS, []],
    [CanvasTemplateOptionEnum.PUBLISHING_NOTIFICATIONS, [
        CanvasTemplateOptionEnum.MAILING_LISTS,
        CanvasTemplateOptionEnum.RECIPIENTS,
        CanvasTemplateOptionEnum.FROM_NAME,
        CanvasTemplateOptionEnum.REPLY_TO,
        CanvasTemplateOptionEnum.INVITE_MESSAGE,
    ]],
]);

// Block-type → option mapping used to build per-block children under Content Blocks.
// CURATED_MENTION_LIST is intentionally excluded per spec.
import { BriefingBlockTypeEnum } from '../../../enums/briefing-block-type.enum';

export const canvasBlockTypeToTemplateContentOptionMap: Map<BriefingBlockTypeEnum, string> = new Map([
    [BriefingBlockTypeEnum.IMAGE,                  'IMAGE'],
    [BriefingBlockTypeEnum.TITLE,                  'TITLE'],
    [BriefingBlockTypeEnum.TEXT,                   'TEXT'],
    [BriefingBlockTypeEnum.DATE,                   'DATE'],
    [BriefingBlockTypeEnum.TABLE_OF_CONTENT,       'TABLE_OF_CONTENTS'],
    [BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST, 'AUTOMATIC_MENTION_LIST'],
    [BriefingBlockTypeEnum.CURATED_MENTION_LIST,   'CURATED_MENTION_LIST'],
    [BriefingBlockTypeEnum.ANALYSIS,               'ANALYSIS'],
    [BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT,      'ONE_COLUMN_LAYOUT'],
    [BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT,      'TWO_COLUMN_LAYOUT'],
    [BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT,    'THREE_COLUMN_LAYOUT'],
    [BriefingBlockTypeEnum.CHART,                  'CHART'],
    [BriefingBlockTypeEnum.COVERAGE_CURATOR,       'COVERAGE_CURATOR'],
    [BriefingBlockTypeEnum.LINK,                   'LINK'],
    [BriefingBlockTypeEnum.DIVIDER,                'DIVIDER'],
]);

// Localization keys for block-type labels (reuse existing email briefing keys)
export const canvasBlockLocalizationKeyMap: Map<string, string> = new Map([
    ['IMAGE',                  'Briefings.briefingSaveTemplateDialog.setTemplateContent.IMAGE'],
    ['DATE',                   'Briefings.briefingSaveTemplateDialog.setTemplateContent.DATE'],
    ['TITLE',                  'Briefings.briefingSaveTemplateDialog.setTemplateContent.TITLE'],
    ['TEXT',                   'Briefings.briefingSaveTemplateDialog.setTemplateContent.TEXT'],
    ['TABLE_OF_CONTENTS',      'Briefings.briefingSaveTemplateDialog.setTemplateContent.TABLE_OF_CONTENTS'],
    ['AUTOMATIC_MENTION_LIST', 'Briefings.briefingSaveTemplateDialog.setTemplateContent.AUTOMATIC_MENTION_LIST'],
    ['CURATED_MENTION_LIST',   'Briefings.briefingSaveTemplateDialog.setTemplateContent.CURATED_MENTION_LIST'],
    ['ANALYSIS',               'Briefings.briefingSaveTemplateDialog.setTemplateContent.ANALYSIS'],
    ['ONE_COLUMN_LAYOUT',      'Briefings.briefingSaveTemplateDialog.setTemplateContent.ONE_COLUMN_LAYOUT'],
    ['TWO_COLUMN_LAYOUT',      'Briefings.briefingSaveTemplateDialog.setTemplateContent.TWO_COLUMN_LAYOUT'],
    ['THREE_COLUMN_LAYOUT',    'Briefings.briefingSaveTemplateDialog.setTemplateContent.THREE_COLUMN_LAYOUT'],
    ['CHART',                  'Briefings.briefingSaveTemplateDialog.setTemplateContent.CHART'],
    ['COVERAGE_CURATOR',       'Briefings.briefingSaveTemplateDialog.setTemplateContent.COVERAGE_CURATOR'],
    ['LINK',                   'Briefings.briefingSaveTemplateDialog.setTemplateContent.LINK'],
    ['DIVIDER',                'Briefings.briefingSaveTemplateDialog.setTemplateContent.DIVIDER'],
]);

export const canvasTemplateOptionLocalizationKeyMap: Map<CanvasTemplateOptionEnum, string> = new Map([
    [CanvasTemplateOptionEnum.STYLES,                  'Briefings.briefingSaveTemplateDialog.setTemplateContent.STYLES'],
    [CanvasTemplateOptionEnum.CONTENT_BLOCK,           'Briefings.briefingSaveTemplateDialog.setTemplateContent.CONTENT_BLOCK'],
    [CanvasTemplateOptionEnum.SECTION_RULES,           'Briefings.briefingSaveTemplateDialog.setTemplateContent.SECTION_RULES'],
    [CanvasTemplateOptionEnum.SCHEDULING,              'Briefings.briefingSaveTemplateDialog.setTemplateContent.SCHEDULING'],
    [CanvasTemplateOptionEnum.MAILING_LISTS,           'Briefings.briefingSaveTemplateDialog.setTemplateContent.MAILING_LISTS'],
    [CanvasTemplateOptionEnum.RECIPIENTS,              'Briefings.briefingSaveTemplateDialog.setTemplateContent.RECIPIENTS'],
    [CanvasTemplateOptionEnum.FROM_NAME,               'Briefings.briefingSaveTemplateDialog.setTemplateContent.FROM_NAME'],
    [CanvasTemplateOptionEnum.REPLY_TO,                'Briefings.briefingSaveTemplateDialog.setTemplateContent.REPLY_TO'],
    // [CanvasTemplateOptionEnum.DIGESTS,                 'Briefings.canvasSaveTemplateDialog.setTemplateContent.DIGESTS'],
    [CanvasTemplateOptionEnum.PUBLISHING_NOTIFICATIONS,'Briefings.canvasSaveTemplateDialog.setTemplateContent.PUBLISHING_NOTIFICATIONS'],
    [CanvasTemplateOptionEnum.INVITE_MESSAGE,          'Briefings.canvasSaveTemplateDialog.setTemplateContent.INVITE_MESSAGE'],
    [CanvasTemplateOptionEnum.NOTIFICATION_STYLE,      'Briefings.canvasSaveTemplateDialog.setTemplateContent.NOTIFICATION_STYLE'],
]);
